import InputWrapper from "./InputWrapper";
import classNames from "classnames";
import {useEffect} from "react";

const DEFAULT_COLOR = "#FF5733";

const Input = ({
                   name,
                   required = false,
                   label,
                   formik,
                   handleBlur,
                   handleChange,
                   type = 'text',
                   description,
                   inputWrapperClassName,
                   checked,
                   layout,
                   value: valueProp,
                   error,
                   ...rest
               }) => {

    const onChange = (e) => {
        if (typeof handleChange === 'function') {
            handleChange(e);
            return
        }

        if (type === 'checkbox') {
            formik?.setFieldValue(name, e.target.checked);
            return
        }

        formik?.handleChange(e);
    }

    const onBlur = (e) => {
        if (typeof handleBlur === 'function') {
            handleBlur(e);
            return
        }

        formik?.handleBlur(e);
    }

    const hasError = error || (formik?.touched[name] && formik?.errors[name]);
    const value = formik ? formik.values[name] : valueProp;

    useEffect(() => {
        if (type === 'color' && !value) {
            formik?.setFieldValue(name, DEFAULT_COLOR);
        }
    }, [type, value]);

    const valueProps = type === 'checkbox'
        ? {checked: checked ?? Boolean(value)}
        : {value: type === 'color' ? value || DEFAULT_COLOR : value ?? ""};

    return (
        <InputWrapper
            formik={formik}
            error={error}
            description={description}
            inputWrapperClassName={inputWrapperClassName}
            layout={layout}
            label={label}
            name={name}
            required={required}
        >
            <input
                {...rest}
                type={type}
                id={name}
                name={name}
                onChange={onChange}
                onBlur={onBlur}
                {...valueProps}
                className={classNames('input', {'has-error': hasError})}
            />
        </InputWrapper>
    )
}

export default Input;